import React from "react";
import Grid from "@mui/material/Grid";
import { useTranslation, Trans } from "react-i18next";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import Cookies from "universal-cookie";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import { brandColors } from "../brandedComponent/BrandedColors";
import { LifeSafer } from "../../_helpers/BrandConstants";
import ContinueButton from "./ContinueButton";
import useMediaQuery from "@mui/material/useMediaQuery";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import slide1 from "../../_images/ISA_Slide1.png";
import slide2 from "../../_images/ISA_Slide2.png";
import slide3 from "../../_images/ISA_Slide3.png";
import wideImage1 from "../../_images/ISA_Wide1.png";
import wideImage2 from "../../_images/ISA_Wide2.png";
import wideImage3 from "../../_images/ISA_Wide3.png";

const Introduction = ({ setActiveStep }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isTabletBig = useMediaQuery(theme.breakpoints.up("sm"));
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const matches900to960 = useMediaQuery(
    "(min-width:900px) and (max-width:960px)",
  );

  const slides = [
    {
      image: isMobileOrTablet ? slide1 : wideImage1,
      text1: t("speed.introductionText1"),
      text2: (
        <Trans
          i18nKey="speed.introductionText2"
          components={{ strong: <strong />, u: <u />, br: <br /> }}
        />
      ),
    },
    {
      image: isMobileOrTablet ? slide2 : wideImage2,
      text1: (
        <Trans
          i18nKey="speed.introductionText3"
          components={{ strong: <strong />, u: <u />, br: <br /> }}
        />
      ),
      text2: "",
    },

    {
      image: isMobileOrTablet ? slide3 : wideImage3,

      text1: t("speed.introductionText4"),
      text2: "",
    },
  ];

  const SliderDesktopView = () => {
    return (
      <Grid
        sx={{
          // height: "90vh",
          width: "100%",
          display: "flex",
          // background: "red",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "40px",
          paddingBottom: "40px",
          // background: "linear-gradient(to bottom, #d6f2c0 0%, #fff 100%)",
        }}
      >
        <Grid
          className="topSection"
          sx={{
            height: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "55px",
            width: "90%",
            "& .carousel-root": {
              height: "100%",
              width: "100%",
            },
            "& .carousel-slider": {
              height: "100%",
            },
            ".control-dots ": {
              right: "45px",
            },
            "& .carousel .slider-wrapper": {
              marginLeft: "30px",
            },
          }}
        >
          <Carousel
            showIndicators={true}
            showThumbs={false}
            infiniteLoop={true}
            showArrows={true}
            showStatus={true}
            useKeyboardArrows={true}
            autoPlay={true}
            stopOnHover={true}
            swipeable={true}
            dynamicHeight={true}
            emulateTouch={true}
            autoFocus={true}
            interval={7500}
            transitionTime={500}
            renderIndicator={(onClickHandler, isSelected, index, label) => {
              const style = {
                marginLeft: 8,
                marginRight: 8,
                width: 6,
                height: 6,
                borderRadius: "50%",
                display: "inline-block",
                backgroundColor: isSelected
                  ? `${brandColors[brand].primary}`
                  : "#ccc",
                cursor: "pointer",
              };
              return (
                <span
                  style={style}
                  onClick={onClickHandler}
                  onKeyDown={onClickHandler}
                  value={index}
                  key={index}
                  role="button"
                  tabIndex={0}
                  aria-label={`${label} ${index + 1}`}
                />
              );
            }}
          >
            {slides.map((slide, index) => (
              <Grid
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid
                  sx={{
                    width: { xs: "100%", sm: "52%" },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Box
                    component="img"
                    src={slide.image}
                    sx={{
                      width: { xs: "100%", sm: "100%", md: "80%" },
                      height: "380px",
                      borderRadius: "10px",
                      objectFit: "cover",
                    }}
                  />
                </Grid>

                <Grid
                  sx={{ width: { xs: "100%", sm: "48%" }, paddingLeft: "16px" }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      paddingLeft: { xs: 0, sm: "15px" },
                      width: { xs: "100%", md: "80%" },

                      textAlign: { xs: "center", sm: "start" },
                      justifyContent: { xs: "center", sm: "flex-start" },
                      // fontWeight: "550",
                      color: `${brandColors[brand].primary}`,
                      lineHeight: 1.6,
                      fontWeight: 500,
                      fontSize: matches900to960 ? "18px !important" : "24px",
                    }}
                  >
                    {slide.text1}
                  </Typography>

                  <Typography
                    variant="h6"
                    sx={{
                      paddingLeft: { xs: 0, sm: "15px" },
                      width: { xs: "93%", md: "75%" },
                      marginTop: "12px",
                      textAlign: { xs: "center", sm: "start" },
                      justifyContent: { xs: "center", sm: "flex-start" },
                      // fontWeight: "550",
                      color: `${brandColors[brand].primary}`,
                      lineHeight: 1.4,
                      fontSize: matches900to960 ? "18px !important" : "24px",
                    }}
                  >
                    {slide.text2}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Carousel>
        </Grid>

        <Grid
          className="downSection"
          sx={{ height: "20%", mt: 3, position: "relative", right: "40px" }}
        >
          <ContinueButton
            submitting={false}
            type="button"
            onClick={() => setActiveStep(1)}
          />
        </Grid>
      </Grid>
    );
  };

  const SliderMobileView = () => {
    return (
      <>
        <Grid
          size={12}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            paddingTop: isTabletBig ? "60px" : "24px",
            paddingBottom: "24px",
            width: "100%",
            marginTop: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              flexDirection: "column",
              // boxShadow: "0px 4px 6px rgba(0,0,0,0.2)",
              paddingBottom: "20px",
              ".control-dots": {
                bottom: "-3px !important",
              },
              paddingLeft: "20px",
              paddingRight: "20px",
              width: "100%",
            }}
          >
            <Carousel
              showIndicators
              showThumbs={false}
              showArrows
              showStatus={false}
              useKeyboardArrows
              autoPlay
              stopOnHover
              swipeable
              emulateTouch
              interval={7500}
              transitionTime={500}
              infiniteLoop
              renderIndicator={(onClickHandler, isSelected, index, label) => {
                const style = {
                  marginLeft: 8,
                  marginRight: 8,
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  display: "inline-block",
                  backgroundColor: isSelected
                    ? `${brandColors[brand].primary}`
                    : "#ccc", // active blue
                  cursor: "pointer",
                };
                return (
                  <span
                    style={style}
                    onClick={onClickHandler}
                    onKeyDown={onClickHandler}
                    value={index}
                    key={index}
                    role="button"
                    tabIndex={0}
                    aria-label={`${label} ${index + 1}`}
                  />
                );
              }}
            >
              {slides.map((slide, index) => (
                <Grid
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    height: "90%",
                  }}
                >
                  <Grid
                    key={index}
                    sx={{
                      minHeight: "460px",
                      display: "flex",
                      flexDirection: "column",
                      width: "90%",
                      gap: 2,
                    }}
                  >
                    <Box
                      component="img"
                      src={slide.image}
                      alt={slide.title}
                      sx={{
                        width: "100%",
                        maxHeight: "320px",
                        objectFit: "cover",
                        borderRadius: "15px",
                      }}
                    />

                    <Typography
                      sx={{
                        color: `${brandColors[brand].primary}`,
                        fontSize: "18px",
                      }}
                    >
                      {slide.text1}
                    </Typography>
                    <Typography
                      sx={{
                        color: `${brandColors[brand].primary}`,
                        fontSize: "18px",
                      }}
                    >
                      {slide.text2}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Carousel>
          </Box>
          <ContinueButton
            submitting={false}
            onClick={() => setActiveStep((prev) => prev + 1)}
          />
        </Grid>
      </>
    );
  };

  return (
    <>
      <Grid
        sx={{
          background: "linear-gradient(to bottom, #d6f2c0 0%, #fff 100%)",
          minWidth: "auto",
          width: "100%",
        }}
      >
        {isMobileOrTablet ? <SliderMobileView /> : <SliderDesktopView />}
      </Grid>
    </>
  );
};

Introduction.propTypes = {
  setActiveStep: PropTypes.func,
};

export default Introduction;
